module.exports = __webpack_public_path__ + "static/img/yeswecan0021.765a25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0021.png
// module id = 587
// module chunks = 1